import { RFIProps } from "@/interfaces/rfi_types";
import { RFICard } from "../Cards/RFICard";
import { SectionDivRow } from "./Components/SectionDivRow";
import { SectionDiv } from "./Components/SectionDiv";

type RFISectionProps = {
    sorted_rfis: RFIProps[],
    isNewCard: (cardType: string, id: string) => boolean,
    markAsSeen: (cardType: string, id: string) => void
}

export function RFISection(
    { sorted_rfis, isNewCard, markAsSeen }: RFISectionProps
) {
    return (
        <SectionDiv>
            <h3>My RFIs:</h3>

            <SectionDivRow>
                {sorted_rfis.length > 0 ? sorted_rfis.map((rfi) => (
                    rfi.status === "Closed" ? null :
                        <RFICard
                            key={rfi.RFI_id}
                            rfi={rfi}
                            isNew={isNewCard('rfi', rfi.RFI_id ?? '')}
                            onView={() => markAsSeen('rfi', rfi.RFI_id ?? '')} />
                ))
                    :
                    <h3>No RFIs assigned to you</h3>}
            </SectionDivRow>
        </SectionDiv>
    );
}
